import React from 'react';
import { connect } from 'react-redux';
import { updateShowViewWaitingAreaModal } from '../../../../actions/modal';

class RightPanelView extends React.Component {
  constructor(props, context) {
    super(props, context);
  }
  closeModal = () => {
    this.props.dispatch(updateShowViewWaitingAreaModal(false));
  };
  render() {
    return (
      <div>
        <div className="ui actions mrbl max-width mrtxxs ">
          <button
            onClick={this.closeModal}
            className="ui cancel  labeled icon button color-bad-things color-bad-things-hover color-white   max-width left-text mrlnull mrbnull"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Close}
          </button>
        </div>
      </div>
    );
  }
}
let reduxGetterSetter = connect()(RightPanelView); //CONNECT IS A REACT HELPER FUNCTION

export default reduxGetterSetter;
